export function triggerPostMessage({ type, data, origin = '*' }) {
  window.parent.postMessage(
    JSON.stringify({
      type,
      ...data,
    }),
    origin,
  );
}
